import { AnnotationMode } from "@/models";
import { AnnotationStateV2, AnnotationObject, CanvasObjectUpdate } from "./state";
import { defineVuexName, MODULES } from "@/store/utils";

export interface AddObjectPayload {
  object: AnnotationObject;
}

export interface UpdateObjectPayload {
  objectId: string;
  metadata: string;
}

export interface RemoveObjectPayload {
  objectId: string;
}

export interface SetObjectsPayload {
  objects: AnnotationObject[];
}

const mutations = {
  // ==================== MODE ====================
  [defineVuexName(MODULES.ANNOTATION_V2.COMMITS.SET_ANNOTATION_MODE)](state: AnnotationStateV2, mode: AnnotationMode) {
    state.mode = mode;
  },

  // ==================== CRUD OPERATIONS ====================

  /**
   * Set/replace all objects (used when loading from server)
   */
  [defineVuexName(MODULES.ANNOTATION_V2.COMMITS.SET_OBJECTS)](state: AnnotationStateV2, payload: SetObjectsPayload) {
    state.objects = payload.objects;
  },

  // ==================== IMAGE DIMENSIONS ====================

  [defineVuexName(MODULES.ANNOTATION_V2.COMMITS.SET_IMAGE_DIMENSIONS)](state: AnnotationStateV2, payload: { width?: number; height?: number }) {
    state.imgWidth = payload.width;
    state.imgHeight = payload.height;
  },

  // ==================== REAL-TIME OBJECT UPDATES ====================

  /**
   * Set next object to be updated (for real-time incremental canvas updates)
   */
  [defineVuexName(MODULES.ANNOTATION_V2.COMMITS.SET_NEXT_OBJECT_TOBE_UPDATED)](state: AnnotationStateV2, payload: CanvasObjectUpdate | undefined) {
    state.nextObjectTobeUpdated = payload;
  },
};

export default mutations;
